(function() {
  var infiniteScrollNextUrl = '';
  var infiniteScrollLoading = false;
  var infiniteScrollPrefetchUrl = '';
  var infiniteScrollPrefetchedDoc = null;
  var infiniteScrollPrefetchPromise = null;
  var urlMerchandisingHydrating = false;
  var deferredInfiniteScrollStart = null;
  var collectionProductsJsonPromise = null;
  var shopifySortValues = [
    'manual',
    'best-selling',
    'title-ascending',
    'title-descending',
    'price-ascending',
    'price-descending',
    'created-ascending',
    'created-descending'
  ];
  var customSortValues = [
    'discount_desc',
    'relevance'
  ];
  var clientSideSortValues = [
    'discount_desc',
    'created-descending'
  ];

  function getCollectionSectionId() {
    var collectionSection = document.querySelector('[js-main-collection][data-section-id]');
    return collectionSection ? collectionSection.getAttribute('data-section-id') : '';
  }

  function getSectionRenderUrl(url) {
    var sectionId = getCollectionSectionId();
    var nextUrl = new URL(url, window.location.origin);

    if (sectionId) {
      nextUrl.searchParams.set('section_id', sectionId);
    }

    return nextUrl.toString();
  }

  // Strips client-side-only params and rewrites brand → filter.p.vendor for backend requests.
  function cleanMerchandisingParams(params) {
    var brand = params.get('brand');
    params.delete('brand');
    params.delete('pin');
    params.delete('offer');
    if (brand) params.set('filter.p.vendor', brand);
  }

  function getCollectionProductsJsonUrl() {
    var url = new URL(window.location.pathname + '/products.json', window.location.origin);
    url.searchParams.set('limit', '250');
    return url.toString();
  }

  function getProductGridItemUrl(handle) {
    return new URL('/products/' + handle + '?view=productGridItem', window.location.origin).toString();
  }

  function getTargetPageRenderUrl(page) {
    var url = new URL(window.location.pathname, window.location.origin);
    var params = new URLSearchParams(window.location.search);

    params.delete('section_id');
    cleanMerchandisingParams(params);

    if (shopifySortValues.indexOf(params.get('sort_by')) === -1) {
      params.delete('sort_by');
    }

    params.set('page', page);
    url.search = params.toString();

    return getSectionRenderUrl(url.toString());
  }

  function getProductDiscount(product) {
    var dataDiscount = parseFloat(product.getAttribute('data-product-discount'));
    return isNaN(dataDiscount) ? 0 : dataDiscount;
  }

  function getProductCreatedAt(product) {
    var createdAt = parseInt(product.getAttribute('data-product-created-at'), 10);
    return isNaN(createdAt) ? 0 : createdAt;
  }

  function getActiveSortValue() {
    return new URLSearchParams(window.location.search).get('sort_by') || '';
  }

  function hasClientSideSort(sortBy) {
    return clientSideSortValues.indexOf(sortBy) !== -1;
  }

  function hasActiveVisibilityFilters() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('brand')) return true;

    var hasFilter = false;
    params.forEach(function(value, key) {
      if (key.indexOf('filter.') === 0) {
        hasFilter = true;
      }
    });

    return hasFilter;
  }

  function isKnownSortValue(sortBy) {
    return shopifySortValues.indexOf(sortBy) !== -1 || customSortValues.indexOf(sortBy) !== -1;
  }

  function isSearchListingPage() {
    return !!document.querySelector('.search-content[js-main-collection]');
  }

  function normalizeToken(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function normalizeHandle(value) {
    return normalizeToken(value).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // ---------------------------------------------------------------------------
  // pin= param parsing
  // Format: pin=<id>,<id>,type:<type>,vendor:<vendor>,tag:<tag>
  // tag: values may contain colons, e.g. tag:offer:new-arrival
  // ---------------------------------------------------------------------------

  function parsePinParam() {
    var pinValue = new URLSearchParams(window.location.search).get('pin') || '';
    var items = pinValue.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    var productIds = [];
    var typeRules = [];
    var vendorRules = [];
    var tagRules = [];
    var orderedRules = [];

    items.forEach(function(item) {
      var lower = item.toLowerCase();
      if (lower.indexOf('type:') === 0) {
        var typeRule = normalizeToken(item.slice(5));
        typeRules.push(typeRule);
        orderedRules.push({ kind: 'type', value: typeRule });
      } else if (lower.indexOf('vendor:') === 0) {
        var vendorRule = normalizeToken(item.slice(7));
        vendorRules.push(vendorRule);
        orderedRules.push({ kind: 'vendor', value: vendorRule });
      } else if (lower.indexOf('tag:') === 0) {
        var tagRule = normalizeToken(item.slice(4));
        tagRules.push(tagRule);
        orderedRules.push({ kind: 'tag', value: tagRule });
      } else {
        productIds.push(normalizeToken(item));
      }
    });

    return {
      productIds: productIds,
      typeRules: typeRules,
      vendorRules: vendorRules,
      tagRules: tagRules,
      orderedRules: orderedRules
    };
  }

  function hasActivePinRules(pinRules) {
    return pinRules.productIds.length > 0 ||
      pinRules.typeRules.length > 0 ||
      pinRules.vendorRules.length > 0 ||
      pinRules.tagRules.length > 0;
  }

  // Returns the sort slot for a product against the pin rules.
  // Lower slot = sorted earlier. Infinity = not pinned, preserve original order.
  // Priority order: all product IDs first, then type/vendor/tag rules in URL order.
  function getPinPriority(product, pinRules) {
    var productId = normalizeToken(product.getAttribute('data-product-id'));
    var i;

    for (i = 0; i < pinRules.productIds.length; i++) {
      if (productId === pinRules.productIds[i]) return i;
    }

    var productType = normalizeToken(product.getAttribute('data-product-type'));
    var vendor = normalizeToken(product.getAttribute('data-product-vendor'));
    var vendorHandle = normalizeHandle(product.getAttribute('data-product-vendor'));
    var tags = (product.getAttribute('data-product-tags') || '').split(',').map(normalizeToken);

    for (i = 0; i < pinRules.orderedRules.length; i++) {
      var rule = pinRules.orderedRules[i];
      var matches =
        (rule.kind === 'type' && productType === rule.value) ||
        (rule.kind === 'vendor' &&
          (vendor === rule.value || vendorHandle === normalizeHandle(rule.value))) ||
        (rule.kind === 'tag' && tags.indexOf(rule.value) !== -1);

      if (matches) return pinRules.productIds.length + i;
    }

    return Infinity;
  }

  function isPinProductIdLoaded(productId) {
    return Array.prototype.some.call(
      document.querySelectorAll('[data-product-id]'),
      function(product) {
        return normalizeToken(product.getAttribute('data-product-id')) === productId;
      }
    );
  }

  function setUrlMerchandisingLoading(isLoading) {
    var wrapper = document.querySelector('.collection-grid__wrapper');
    document.documentElement.classList.toggle('collection-url-loading', !!isLoading);
    if (!wrapper) return;

    if (isLoading) {
      wrapper.style.setProperty('--collection-loading-height', wrapper.offsetHeight + 'px');
      wrapper.classList.add('unload');
    } else {
      wrapper.classList.remove('unload');
      wrapper.style.removeProperty('--collection-loading-height');
    }
  }

  function refreshCollectionGridLayout() {
    repositionCustomGridImages();
    repositionInlineGridFilters();
  }

  function getCollectionProductsJson() {
    if (collectionProductsJsonPromise) return collectionProductsJsonPromise;

    collectionProductsJsonPromise = fetch(getCollectionProductsJsonUrl())
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        return data && data.products ? data.products : [];
      })
      .catch(function() {
        return [];
      });

    return collectionProductsJsonPromise;
  }

  function findProductHandleById(productId) {
    return getCollectionProductsJson().then(function(products) {
      var matchedProduct = null;

      products.some(function(product) {
        var matchesProductId = normalizeToken(product.id) === productId;
        if (matchesProductId) {
          matchedProduct = product;
        }

        return matchesProductId;
      });

      return matchedProduct ? matchedProduct.handle : '';
    });
  }

  function fetchProductGridItemByHandle(handle) {
    if (!handle) return Promise.resolve(null);

    return fetchCollectionPage(getProductGridItemUrl(handle))
      .then(function(doc) {
        return doc.querySelector('[data-product-id]');
      })
      .catch(function() {
        return null;
      });
  }

  // For pinned product IDs, tries to fetch each card directly by handle in parallel.
  // Any IDs not found this way will be picked up by the sequential loadMoreMatches loop.
  function loadPinProductCardDirectly(pinRules) {
    var grid = document.getElementById('collection_grid_in_new');
    if (!grid || !pinRules.productIds.length) return Promise.resolve(false);
    if (hasActiveVisibilityFilters()) return Promise.resolve(false);

    var unloadedIds = pinRules.productIds.filter(function(id) {
      return !isPinProductIdLoaded(id);
    });
    if (!unloadedIds.length) return Promise.resolve(false);

    var found = {};

    var handlePromises = unloadedIds.map(function(id) {
      return findProductHandleById(id).then(fetchProductGridItemByHandle).then(function(product) {
        if (product) found[id] = product;
      });
    });

    return Promise.all(handlePromises).then(function() {
      var anyLoaded = false;
      unloadedIds.forEach(function(id) {
        var product = found[id];
        if (!product) return;
        if (!isPinProductIdLoaded(id)) {
          grid.insertBefore(product, grid.firstChild);
          anyLoaded = true;
        }
      });
      if (anyLoaded && window.theme && theme.reinitProductGridItem) {
        theme.reinitProductGridItem();
      }
      if (anyLoaded) applyUrlMerchandising();
      return anyLoaded;
    });
  }

  // For product ID pins: continue until all IDs are found or pages exhausted.
  // For type/vendor/tag pins: loop through all pages so every matching product is surfaced.
  function shouldHydrateMoreProducts(pinRules) {
    if (!infiniteScrollNextUrl || !hasActivePinRules(pinRules)) return false;
    if (pinRules.typeRules.length || pinRules.vendorRules.length || pinRules.tagRules.length) return true;
    return pinRules.productIds.some(function(id) { return !isPinProductIdLoaded(id); });
  }

  function applyUrlMerchandising(skipLayoutRefresh) {
    if (isSearchListingPage()) return;

    var grid = document.getElementById('collection_grid_in_new');
    if (!grid) return;

    var pinRules = parsePinParam();
    if (!hasActivePinRules(pinRules)) return;

    var productSelector = '.grid-product[data-product-id], .product_grid_new[data-product-id]';
    var products = Array.prototype.slice.call(grid.querySelectorAll(productSelector));

    products.forEach(function(product) { product.style.display = ''; });

    var indexed = products.map(function(product, i) {
      return { product: product, originalIndex: i, priority: getPinPriority(product, pinRules) };
    });

    indexed.sort(function(a, b) {
      if (a.priority !== b.priority) return a.priority - b.priority;
      return a.originalIndex - b.originalIndex;
    });

    indexed.forEach(function(item) { grid.appendChild(item.product); });

    if (!skipLayoutRefresh) {
      refreshCollectionGridLayout();
    }
  }

  function hydrateUrlMerchandisingProducts() {
    if (isSearchListingPage()) return;

    var pinRules = parsePinParam();
    if (urlMerchandisingHydrating || !hasActivePinRules(pinRules)) return;

    urlMerchandisingHydrating = true;
    setUrlMerchandisingLoading(true);

    loadPinProductCardDirectly(pinRules).then(function() {
      if (!shouldHydrateMoreProducts(pinRules)) {
        urlMerchandisingHydrating = false;
        setUrlMerchandisingLoading(false);
        applyUrlMerchandising();
        return;
      }

      loadMoreMatches();
    });

    function loadMoreMatches() {
      if (infiniteScrollLoading) {
        window.setTimeout(loadMoreMatches, 100);
        return;
      }

      if (!shouldHydrateMoreProducts(pinRules)) {
        urlMerchandisingHydrating = false;
        setUrlMerchandisingLoading(false);
        applyUrlMerchandising();
        return;
      }

      loadNextCollectionPage()
        .then(loadMoreMatches)
        .catch(function() {
          urlMerchandisingHydrating = false;
          setUrlMerchandisingLoading(false);
        });
    }
  }

  // On page load, if URL contains brand=X (the masked form), fetch the collection
  // with filter.p.vendor=X and replace the grid content. Browser URL is not changed.
  function loadBrandFilteredPage() {
    var brand = new URLSearchParams(window.location.search).get('brand');
    if (!brand) return Promise.resolve();

    var url = new URL(window.location.pathname, window.location.origin);
    var params = new URLSearchParams(window.location.search);
    params.delete('brand');
    params.delete('pin');
    params.delete('offer');
    params.set('filter.p.vendor', brand);
    url.search = params.toString();

    return fetchCollectionPage(getSectionRenderUrl(url.toString()))
      .then(function(doc) {
        var grid = document.getElementById('collection_grid_in_new');
        var fetchedGrid = doc.getElementById('collection_grid_in_new');
        if (!grid || !fetchedGrid) return;

        while (grid.firstChild) grid.removeChild(grid.firstChild);

        Array.prototype.slice.call(fetchedGrid.childNodes).forEach(function(node) {
          grid.appendChild(node);
        });

        var nextLink = doc.querySelector('.pagination .next a, .pagination a[rel="next"]');
        infiniteScrollNextUrl = nextLink ? getSectionRenderUrl(nextLink.getAttribute('href')) : '';

        if (window.theme && theme.reinitProductGridItem) {
          theme.reinitProductGridItem();
        }
      })
      .catch(function() {});
  }

  function sortLoadedProducts(compareFn) {
    var grid = document.getElementById('collection_grid_in_new');
    if (!grid) return;

    var products = Array.prototype.slice.call(
      grid.querySelectorAll('.grid-product[data-product-id], .product_grid_new[data-product-id]')
    ).filter(function(product) {
      return !product.classList.contains('collection_grid_customdetail_new') &&
        !product.classList.contains('Collection_grid_saveprice_main_new');
    });

    products.sort(compareFn);

    var fragment = document.createDocumentFragment();
    products.forEach(function(product) {
      fragment.appendChild(product);
    });
    grid.appendChild(fragment);
  }

  function applyClientSideSort() {
    var sortBy = getActiveSortValue();

    if (!hasClientSideSort(sortBy)) return;

    if (sortBy === 'discount_desc') {
      sortLoadedProducts(function(a, b) {
        return getProductDiscount(b) - getProductDiscount(a);
      });
      return;
    }

    if (sortBy === 'created-descending') {
      sortLoadedProducts(function(a, b) {
        return getProductCreatedAt(b) - getProductCreatedAt(a);
      });
    }
  }

  function getIntegerAttribute(element, attribute) {
    var value = parseInt(element.getAttribute(attribute), 10);
    return isNaN(value) ? 0 : value;
  }

  function getCustomGridImagePosition(customGridImage) {
    var desktopPosition = getIntegerAttribute(customGridImage, 'data-custom-grid-image-desktop-position');
    var mobilePosition = getIntegerAttribute(customGridImage, 'data-custom-grid-image-mobile-position');
    var fallbackPosition = getIntegerAttribute(customGridImage, 'data-custom-grid-image-position');
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      return mobilePosition || desktopPosition || fallbackPosition;
    }

    return desktopPosition || mobilePosition || fallbackPosition;
  }

  function repositionCustomGridImages() {
    var grid = document.getElementById('collection_grid_in_new');
    if (!grid) return;

    var customGridImages = Array.prototype.slice.call(
      grid.querySelectorAll('.collection-grid-custom-image[data-custom-grid-image-position]')
    );

    if (!customGridImages.length) return;

    var products = Array.prototype.slice.call(
      grid.querySelectorAll('.grid-product[data-product-id], .product_grid_new[data-product-id]')
    ).filter(function(product) {
      return !product.classList.contains('collection_grid_customdetail_new') &&
        !product.classList.contains('Collection_grid_saveprice_main_new');
    });

    customGridImages
      .sort(function(a, b) {
        return getCustomGridImagePosition(a) - getCustomGridImagePosition(b);
      })
      .forEach(function(customGridImage) {
        var position = getCustomGridImagePosition(customGridImage);
        var targetProduct = products[position - 1];

        if (targetProduct) {
          customGridImage.style.display = '';
          grid.insertBefore(customGridImage, targetProduct);
        } else if (products.length && position <= products.length + 1) {
          customGridImage.style.display = '';
          grid.insertBefore(customGridImage, products[products.length - 1].nextSibling);
        } else {
          grid.appendChild(customGridImage);
          customGridImage.style.display = 'none';
        }
      });
  }

  function repositionInlineGridFilters() {
    var grid = document.getElementById('collection_grid_in_new');
    if (!grid) return;

    var inlineFilters = Array.prototype.slice.call(
      grid.querySelectorAll('.collection-grid-inline-filter-item[data-inline-filter-position]')
    );

    if (!inlineFilters.length) return;

    var products = Array.prototype.slice.call(
      grid.querySelectorAll('.grid-product[data-product-id], .product_grid_new[data-product-id]')
    ).filter(function(product) {
      return !product.classList.contains('collection_grid_customdetail_new') &&
        !product.classList.contains('Collection_grid_saveprice_main_new');
    });

    inlineFilters
      .sort(function(a, b) {
        return parseInt(a.getAttribute('data-inline-filter-position'), 10) -
          parseInt(b.getAttribute('data-inline-filter-position'), 10);
      })
      .forEach(function(inlineFilter) {
        var position = parseInt(inlineFilter.getAttribute('data-inline-filter-position'), 10);
        var targetProduct = products[position - 1];

        if (targetProduct) {
          grid.insertBefore(inlineFilter, targetProduct.nextSibling);
        } else if (products.length) {
          grid.insertBefore(inlineFilter, products[products.length - 1].nextSibling);
        }
      });
  }

  function appendProductsFromPage(doc) {
    var grid = document.getElementById('collection_grid_in_new');
    var nextGrid = doc.getElementById('collection_grid_in_new');
    if (!grid || !nextGrid) return;

    Array.prototype.slice.call(nextGrid.children).forEach(function(item) {
      var isProduct = item.matches('.grid-product[data-product-id], .product_grid_new[data-product-id]');
      var isInlineFilter = item.matches('.collection-grid-inline-filter-item[data-inline-filter-position]');
      var isCustomGridImage = item.matches('.collection-grid-custom-image[data-custom-grid-image-key]');

      if (!isProduct && !isInlineFilter && !isCustomGridImage) return;

      if (isProduct) {
        var productId = normalizeToken(item.getAttribute('data-product-id'));
        var duplicateProduct = Array.prototype.some.call(
          grid.querySelectorAll('[data-product-id]'),
          function(loadedProduct) {
            return normalizeToken(loadedProduct.getAttribute('data-product-id')) === productId;
          }
        );

        if (duplicateProduct) return;
      }

      if (isInlineFilter) {
        var filterPosition = item.getAttribute('data-inline-filter-position');
        var duplicateInlineFilter = grid.querySelector(
          '.collection-grid-inline-filter-item[data-inline-filter-position="' + filterPosition + '"]'
        );

        if (duplicateInlineFilter) return;
      }

      if (isCustomGridImage) {
        var customGridImageKey = item.getAttribute('data-custom-grid-image-key');
        var duplicateCustomGridImage = grid.querySelector(
          '.collection-grid-custom-image[data-custom-grid-image-key="' + customGridImageKey + '"]'
        );

        if (duplicateCustomGridImage) return;
      }

      grid.appendChild(item);
    });

  }

  function fetchCollectionPage(url) {
    return fetch(url)
      .then(function(response) {
        return response.text();
      })
      .then(function(responseText) {
        return new DOMParser().parseFromString(responseText, 'text/html');
      });
  }

  function prefetchNextCollectionPage() {
    if (!infiniteScrollNextUrl || infiniteScrollPrefetchUrl === infiniteScrollNextUrl) return;

    infiniteScrollPrefetchUrl = infiniteScrollNextUrl;
    infiniteScrollPrefetchedDoc = null;

    infiniteScrollPrefetchPromise = fetchCollectionPage(infiniteScrollNextUrl)
      .then(function(doc) {
        infiniteScrollPrefetchedDoc = doc;
        return doc;
      })
      .catch(function() {
        infiniteScrollPrefetchUrl = '';
        infiniteScrollPrefetchedDoc = null;
        infiniteScrollPrefetchPromise = null;
      });
  }

  function loadNextCollectionPage() {
    if (infiniteScrollLoading || !infiniteScrollNextUrl) {
      return Promise.resolve();
    }

    infiniteScrollLoading = true;

    var nextUrl = infiniteScrollNextUrl;
    var pagePromise = infiniteScrollPrefetchedDoc && infiniteScrollPrefetchUrl === nextUrl
      ? Promise.resolve(infiniteScrollPrefetchedDoc)
      : infiniteScrollPrefetchPromise && infiniteScrollPrefetchUrl === nextUrl
        ? infiniteScrollPrefetchPromise
        : fetchCollectionPage(nextUrl);

    return pagePromise
      .then(function(doc) {
        infiniteScrollPrefetchedDoc = null;
        infiniteScrollPrefetchPromise = null;
        infiniteScrollPrefetchUrl = '';

        var nextLink = doc.querySelector('.pagination .next a, .pagination a[rel="next"]');
        var nextHref = nextLink ? nextLink.getAttribute('href') : '';

        appendProductsFromPage(doc);

        infiniteScrollNextUrl = nextHref
          ? getSectionRenderUrl(nextHref)
          : '';

        if (!infiniteScrollNextUrl && window.collectionInfiniteScrollObserver) {
          window.collectionInfiniteScrollObserver.disconnect();
          window.collectionInfiniteScrollObserver = null;
        }

        if (window.theme && theme.reinitProductGridItem) {
          theme.reinitProductGridItem();
        }

        applyClientSideSort();
        applyUrlMerchandising(true);
        refreshCollectionGridLayout();
        prefetchNextCollectionPage();
      })
      .finally(function() {
        infiniteScrollLoading = false;
      });
  }

  function clearDeferredInfiniteScrollStart() {
    if (!deferredInfiniteScrollStart) return;

    window.removeEventListener('scroll', deferredInfiniteScrollStart);
    deferredInfiniteScrollStart = null;
  }

  function observeInfiniteScrollSentinel(sentinel) {
    if (!sentinel || window.collectionInfiniteScrollObserver || !('IntersectionObserver' in window)) return;

    window.collectionInfiniteScrollObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        loadNextCollectionPage();
      }
    }, {
      rootMargin: '1800px 0px',
      threshold: 0
    });

    window.collectionInfiniteScrollObserver.observe(sentinel);
  }

  function deferInfiniteScrollUntilScroll(sentinel) {
    clearDeferredInfiniteScrollStart();

    deferredInfiniteScrollStart = function() {
      clearDeferredInfiniteScrollStart();
      observeInfiniteScrollSentinel(sentinel);
      prefetchNextCollectionPage();
    };

    window.addEventListener('scroll', deferredInfiniteScrollStart);
  }

  function initInfiniteScroll(event) {
    if (window.collectionInfiniteScrollObserver) {
      window.collectionInfiniteScrollObserver.disconnect();
      window.collectionInfiniteScrollObserver = null;
    }
    clearDeferredInfiniteScrollStart();

    var pagination = document.querySelector('.pagination');
    var nextLink = document.querySelector('.pagination .next a, .pagination a[rel="next"]');
    var pinRules = parsePinParam();
    var shouldDeferAfterReload = event && event.type === 'collection:reloaded' && !hasActivePinRules(pinRules);
    var hasBrand = !!new URLSearchParams(window.location.search).get('brand');

    if (pagination) pagination.style.display = 'none';

    var existingSentinel = document.getElementById('CollectionInfiniteScrollSentinel');
    if (existingSentinel) existingSentinel.remove();

    infiniteScrollNextUrl = nextLink ? getSectionRenderUrl(nextLink.href) : '';
    infiniteScrollLoading = false;
    infiniteScrollPrefetchUrl = '';
    infiniteScrollPrefetchedDoc = null;
    infiniteScrollPrefetchPromise = null;
    collectionProductsJsonPromise = null;

    // Show loading overlay before brand fetch so the unfiltered server-rendered grid
    // is never visible. hydrateUrlMerchandisingProducts manages its own overlay for pin rules.
    if (hasBrand) setUrlMerchandisingLoading(true);

    loadBrandFilteredPage().then(function() {
      applyClientSideSort();
      applyUrlMerchandising(true);
      refreshCollectionGridLayout();
      hydrateUrlMerchandisingProducts();

      if (isSearchListingPage() || !hasActivePinRules(pinRules)) {
        setUrlMerchandisingLoading(false);
      }

      var grid = document.getElementById('collection_grid_in_new');
      if (!grid || !infiniteScrollNextUrl || !('IntersectionObserver' in window)) return;

      var sentinel = document.createElement('div');
      sentinel.id = 'CollectionInfiniteScrollSentinel';
      sentinel.className = 'collection-infinite-scroll-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      grid.parentNode.insertBefore(sentinel, grid.nextSibling);

      if (shouldDeferAfterReload) {
        deferInfiniteScrollUntilScroll(sentinel);
        return;
      }

      observeInfiniteScrollSentinel(sentinel);
      prefetchNextCollectionPage();
    });
  }

  var customGridImageResizeTimer = null;

  function handleCustomGridImageResize() {
    window.clearTimeout(customGridImageResizeTimer);
    customGridImageResizeTimer = window.setTimeout(function() {
      refreshCollectionGridLayout();
    }, 150);
  }

  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  document.addEventListener('collection:reloaded', initInfiniteScroll);
  window.addEventListener('resize', handleCustomGridImageResize);
})();
